import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { IntegradorService } from '../../../../services/integrador.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../../services/toast.service';
import { Provisao77p } from '../../../../types/Provisao77p.type';

@Component({
  selector: 'app-provisao77p',
  templateUrl: './provisao77p.component.html',
  styleUrl: './provisao77p.component.css',
  providers: [ConfirmationService]
})
export class Provisao77pComponent implements OnInit {
  loading: boolean = false;
  provisoes77p: Provisao77p[] = []

  constructor(private integradorService: IntegradorService, private router: Router,
              private toastService: ToastService, private confirmationService: ConfirmationService) {}

  ngOnInit(){
    this.carregarProvisoes();
  }

  carregarProvisoes(){
    this.loading = true;
    this.provisoes77p = [];
    this.integradorService.getProvisoes77p().subscribe({
      next: (data) => {
        this.provisoes77p = data
      },
      error: (error) => {
        this.loading = false;
        this.toastService.erro("Erro", error.error.message);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  abreNovoDialog() {
    this.router.navigate(["novo"])
  }

  excluir(id: string){
    this.integradorService.deleteProvisao77p(id).subscribe({
      next: () => {
        this.toastService.sucesso("Sucesso", "Provisão excluída com sucesso");
        this.carregarProvisoes();
      },
      error: (value) => {
       this.toastService.erro("Erro", "Erro ao excluir: " + value)
      }
    })
  }

  confirmarExclusao(id: string) {
    this.confirmationService.confirm({
      message: 'Tem certeza de que deseja excluir ?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.excluir(id);
      }
      });
  }
}
